import React, { FC, useState } from 'react'
import { Typography } from 'react-components'
import { CTAButton, StyledGhostButton } from '../style'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { SearchbarFieldsReturn } from '../hooks/use-searchbar'
import get from 'lodash/get'
import isInquiryButtonVisible from '../side-bar/utils/is-inquiry-button-visible'
import getChildrenAges from '../utils/get-children-ages'
import useDynamicQueryParams from '../hooks/use-dynamic-query-params'
import { ParsedUrlQuery } from 'querystring'

type BookNowButtonProps = {
    query: ParsedUrlQuery
    bookingType: FormattedBookingTypeData | null
    searchbar: SearchbarFieldsReturn
}

const BookNowButton: FC<BookNowButtonProps> = props => {
    const [isLoading, setIsLoading] = useState(false)
    const { bookingType, query, searchbar } = props
    const dynamicQueryParams = JSON.parse(get(bookingType, 'dynamicQueryParams', '') || '')
    const childrenAges = getChildrenAges(searchbar.kids)
    const qpValues = { ...query, ...searchbar, childrenAges }
    const url = useDynamicQueryParams(bookingType, qpValues, dynamicQueryParams)
    const isPrimary = !isInquiryButtonVisible({ bookingType })
    const type = get(bookingType, 'type')

    const onBookNowClick = (event: React.MouseEvent) => {
        if (type === 'redirect') {
            event.preventDefault()
            setIsLoading(true)
            window.open(url, '_blank')
            setIsLoading(false)
        } else {
            setIsLoading(true)
            setTimeout(() => {
                setIsLoading(false)
            }, 5000)
        }
    }

    return (
        <CTAButton onClick={onBookNowClick}>
            <StyledGhostButton isPrimary={isPrimary} disabled={isLoading} loading={isLoading} href={url}>
                <Typography variant="subtitle2" fontWeight="regular">
                    {get(bookingType, 'title')}
                </Typography>
            </StyledGhostButton>
        </CTAButton>
    )
}

export default BookNowButton
